import { SDKResponse } from '@commercetools/frontend-sdk';
import useSWR from 'swr';
import { sdk } from 'sdk';
import { ProjectSettings } from 'shared/types/ProjectSettings';

const useProjectSettings = () => {
  const response = useSWR<SDKResponse<ProjectSettings>>(
    'action/project/getProjectSettings',
    async () => {
      const result = await sdk.callAction<ProjectSettings>({ actionName: 'project/getProjectSettings' });

      // Throw so SWR retries the request and keeps the last good settings
      if (result.isError) throw new Error('Unable to load project settings');

      return result;
    },
    // These rarely change, so don't refetch once they have loaded
    { revalidateIfStale: false, revalidateOnFocus: false },
  );

  const settings = response.data && !response.data.isError ? response.data.data : undefined;
  const data = (settings ?? (response.error ? {} : undefined)) as ProjectSettings;

  return { ...response, data };
};

export default useProjectSettings;
